import { defineComponent as Qt, h as l, Fragment as Zt, ref as p, toRef as ue, computed as C, onMounted as en, getCurrentInstance as tn, watchEffect as de, watch as ce, provide as nn, nextTick as fe } from "vue";
import { useRtl as on } from "./highrise1067.mjs";
import { isSafari as rn } from "./highrise1069.mjs";
import { inputInjectionKey as ln } from "./highrise1139.mjs";
import an, { safariStyle as sn } from "./highrise1140.mjs";
import { useCursor as un, isEmptyInputValue as L } from "./highrise1141.mjs";
import he from "./highrise1142.mjs";
import { resolveWrappedSlot as j, resolveSlot as ne } from "./highrise1059.mjs";
import dn from "./highrise1093.mjs";
import cn from "./highrise1125.mjs";
import fn from "./highrise1053.mjs";
import be from "./highrise984.mjs";
import hn from "./highrise1101.mjs";
import vn from "./highrise1105.mjs";
import pn from "./highrise634.mjs";
import gn from "./highrise1056.mjs";
import ve from "./highrise628.mjs";
import { createKey as oe } from "./highrise314.mjs";
import { getMargin as mn } from "./highrise1080.mjs";
import { useThemeClass as yn } from "./highrise1062.mjs";
import pe from "./highrise1143.mjs";
import bn from "./highrise1144.mjs";
import ge from "./highrise1104.mjs";
import xn from "./highrise1145.mjs";
import wn from "./highrise1146.mjs";
import Cn from "./highrise1013.mjs";
import { on as me, off as ye } from "./highrise632.mjs";
import { call as g } from "./highrise1077.mjs";
const Sn = Object.assign(Object.assign({}, be.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: !1
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: !1
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: !0
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: !0
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: [Function, Array],
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  /** private */
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: {
    type: Boolean,
    default: !0
  },
  /** deprecated */
  showPasswordToggle: Boolean
}), Qn = Qt({
  name: "Input",
  props: Sn,
  slots: Object,
  setup(n) {
    const {
      mergedClsPrefixRef: y,
      mergedBorderedRef: r,
      inlineThemeDisabled: P,
      mergedRtlRef: G
    } = fn(n), b = be("Input", "-input", an, Cn, n, y);
    rn && hn("-input-safari", sn, y);
    const v = p(null), f = p(null), c = p(null), i = p(null), a = p(null), h = p(null), m = p(null), D = un(m), S = p(null), {
      localeRef: xe
    } = vn("Input"), W = p(n.defaultValue), we = ue(n, "value"), x = pn(we, W), I = gn(n), {
      mergedSizeRef: X,
      mergedDisabledRef: _,
      mergedStatusRef: Ce
    } = I, B = p(!1), T = p(!1), w = p(!1), $ = p(!1);
    let Y = null;
    const q = C(() => {
      const {
        placeholder: e,
        pair: t
      } = n;
      return t ? Array.isArray(e) ? e : e === void 0 ? ["", ""] : [e, e] : e === void 0 ? [xe.value.placeholder] : [e];
    }), Se = C(() => {
      const {
        value: e
      } = w, {
        value: t
      } = x, {
        value: o
      } = q;
      return !e && (L(t) || Array.isArray(t) && L(t[0])) && o[0];
    }), Ae = C(() => {
      const {
        value: e
      } = w, {
        value: t
      } = x, {
        value: o
      } = q;
      return !e && o[1] && (L(t) || Array.isArray(t) && L(t[1]));
    }), J = ve(() => n.internalForceFocus || B.value), Fe = ve(() => {
      if (_.value || n.readonly || !n.clearable || !J.value && !T.value)
        return !1;
      const {
        value: e
      } = x, {
        value: t
      } = J;
      return n.pair ? !!(Array.isArray(e) && (e[0] || e[1])) && (T.value || t) : !!e && (T.value || t);
    }), Q = C(() => {
      const {
        showPasswordOn: e
      } = n;
      if (e)
        return e;
      if (n.showPasswordToggle) return "click";
    }), V = p(!1), Re = C(() => {
      const {
        textDecoration: e
      } = n;
      return e ? Array.isArray(e) ? e.map((t) => ({
        textDecoration: t
      })) : [{
        textDecoration: e
      }] : ["", ""];
    }), re = p(void 0), _e = () => {
      var e, t;
      if (n.type === "textarea") {
        const {
          autosize: o
        } = n;
        if (o && (re.value = (t = (e = S.value) === null || e === void 0 ? void 0 : e.$el) === null || t === void 0 ? void 0 : t.offsetWidth), !f.value || typeof o == "boolean") return;
        const {
          paddingTop: u,
          paddingBottom: d,
          lineHeight: s
        } = window.getComputedStyle(f.value), A = Number(u.slice(0, -2)), F = Number(d.slice(0, -2)), R = Number(s.slice(0, -2)), {
          value: z
        } = c;
        if (!z) return;
        if (o.minRows) {
          const M = Math.max(o.minRows, 1), te = `${A + F + R * M}px`;
          z.style.minHeight = te;
        }
        if (o.maxRows) {
          const M = `${A + F + R * o.maxRows}px`;
          z.style.maxHeight = M;
        }
      }
    }, Be = C(() => {
      const {
        maxlength: e
      } = n;
      return e === void 0 ? void 0 : Number(e);
    });
    en(() => {
      const {
        value: e
      } = x;
      Array.isArray(e) || ee(e);
    });
    const Ee = tn().proxy;
    function O(e, t) {
      const {
        onUpdateValue: o,
        "onUpdate:value": u,
        onInput: d
      } = n, {
        nTriggerFormInput: s
      } = I;
      o && g(o, e, t), u && g(u, e, t), d && g(d, e, t), W.value = e, s();
    }
    function k(e, t) {
      const {
        onChange: o
      } = n, {
        nTriggerFormChange: u
      } = I;
      o && g(o, e, t), W.value = e, u();
    }
    function Pe(e) {
      const {
        onBlur: t
      } = n, {
        nTriggerFormBlur: o
      } = I;
      t && g(t, e), o();
    }
    function Ie(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: o
      } = I;
      t && g(t, e), o();
    }
    function Te(e) {
      const {
        onClear: t
      } = n;
      t && g(t, e);
    }
    function $e(e) {
      const {
        onInputBlur: t
      } = n;
      t && g(t, e);
    }
    function Ve(e) {
      const {
        onInputFocus: t
      } = n;
      t && g(t, e);
    }
    function ze() {
      const {
        onDeactivate: e
      } = n;
      e && g(e);
    }
    function Me() {
      const {
        onActivate: e
      } = n;
      e && g(e);
    }
    function De(e) {
      const {
        onClick: t
      } = n;
      t && g(t, e);
    }
    function We(e) {
      const {
        onWrapperFocus: t
      } = n;
      t && g(t, e);
    }
    function Oe(e) {
      const {
        onWrapperBlur: t
      } = n;
      t && g(t, e);
    }
    function ke() {
      w.value = !0;
    }
    function He(e) {
      w.value = !1, e.target === h.value ? H(e, 1) : H(e, 0);
    }
    function H(e, t = 0, o = "input") {
      const u = e.target.value;
      if (ee(u), e instanceof InputEvent && !e.isComposing && (w.value = !1), n.type === "textarea") {
        const {
          value: s
        } = S;
        s && s.syncUnifiedContainer();
      }
      if (Y = u, w.value) return;
      D.recordCursor();
      const d = Ne(u);
      if (d)
        if (!n.pair)
          o === "input" ? O(u, {
            source: t
          }) : k(u, {
            source: t
          });
        else {
          let {
            value: s
          } = x;
          Array.isArray(s) ? s = [s[0], s[1]] : s = ["", ""], s[t] = u, o === "input" ? O(s, {
            source: t
          }) : k(s, {
            source: t
          });
        }
      Ee.$forceUpdate(), d || fe(D.restoreCursor);
    }
    function Ne(e) {
      const {
        countGraphemes: t,
        maxlength: o,
        minlength: u
      } = n;
      if (t) {
        let s;
        if (o !== void 0 && (s === void 0 && (s = t(e)), s > Number(o)) || u !== void 0 && (s === void 0 && (s = t(e)), s < Number(o)))
          return !1;
      }
      const {
        allowInput: d
      } = n;
      return typeof d == "function" ? d(e) : !0;
    }
    function Ke(e) {
      $e(e), e.relatedTarget === v.value && ze(), e.relatedTarget !== null && (e.relatedTarget === a.value || e.relatedTarget === h.value || e.relatedTarget === f.value) || ($.value = !1), N(e, "blur"), m.value = null;
    }
    function Ue(e, t) {
      Ve(e), B.value = !0, $.value = !0, Me(), N(e, "focus"), t === 0 ? m.value = a.value : t === 1 ? m.value = h.value : t === 2 && (m.value = f.value);
    }
    function Le(e) {
      n.passivelyActivated && (Oe(e), N(e, "blur"));
    }
    function je(e) {
      n.passivelyActivated && (B.value = !0, We(e), N(e, "focus"));
    }
    function N(e, t) {
      e.relatedTarget !== null && (e.relatedTarget === a.value || e.relatedTarget === h.value || e.relatedTarget === f.value || e.relatedTarget === v.value) || (t === "focus" ? (Ie(e), B.value = !0) : t === "blur" && (Pe(e), B.value = !1));
    }
    function Ge(e, t) {
      H(e, t, "change");
    }
    function Xe(e) {
      De(e);
    }
    function Ye(e) {
      Te(e), le();
    }
    function le() {
      n.pair ? (O(["", ""], {
        source: "clear"
      }), k(["", ""], {
        source: "clear"
      })) : (O("", {
        source: "clear"
      }), k("", {
        source: "clear"
      }));
    }
    function qe(e) {
      const {
        onMousedown: t
      } = n;
      t && t(e);
      const {
        tagName: o
      } = e.target;
      if (o !== "INPUT" && o !== "TEXTAREA") {
        if (n.resizable) {
          const {
            value: u
          } = v;
          if (u) {
            const {
              left: d,
              top: s,
              width: A,
              height: F
            } = u.getBoundingClientRect(), R = 14;
            if (d + A - R < e.clientX && e.clientX < d + A && s + F - R < e.clientY && e.clientY < s + F)
              return;
          }
        }
        e.preventDefault(), B.value || ae();
      }
    }
    function Je() {
      var e;
      T.value = !0, n.type === "textarea" && ((e = S.value) === null || e === void 0 || e.handleMouseEnterWrapper());
    }
    function Qe() {
      var e;
      T.value = !1, n.type === "textarea" && ((e = S.value) === null || e === void 0 || e.handleMouseLeaveWrapper());
    }
    function Ze() {
      _.value || Q.value === "click" && (V.value = !V.value);
    }
    function et(e) {
      if (_.value) return;
      e.preventDefault();
      const t = (u) => {
        u.preventDefault(), ye("mouseup", document, t);
      };
      if (me("mouseup", document, t), Q.value !== "mousedown") return;
      V.value = !0;
      const o = () => {
        V.value = !1, ye("mouseup", document, o);
      };
      me("mouseup", document, o);
    }
    function tt(e) {
      n.onKeyup && g(n.onKeyup, e);
    }
    function nt(e) {
      switch (n.onKeydown && g(n.onKeydown, e), e.key) {
        case "Escape":
          Z();
          break;
        case "Enter":
          ot(e);
          break;
      }
    }
    function ot(e) {
      var t, o;
      if (n.passivelyActivated) {
        const {
          value: u
        } = $;
        if (u) {
          n.internalDeactivateOnEnter && Z();
          return;
        }
        e.preventDefault(), n.type === "textarea" ? (t = f.value) === null || t === void 0 || t.focus() : (o = a.value) === null || o === void 0 || o.focus();
      }
    }
    function Z() {
      n.passivelyActivated && ($.value = !1, fe(() => {
        var e;
        (e = v.value) === null || e === void 0 || e.focus();
      }));
    }
    function ae() {
      var e, t, o;
      _.value || (n.passivelyActivated ? (e = v.value) === null || e === void 0 || e.focus() : ((t = f.value) === null || t === void 0 || t.focus(), (o = a.value) === null || o === void 0 || o.focus()));
    }
    function rt() {
      var e;
      !((e = v.value) === null || e === void 0) && e.contains(document.activeElement) && document.activeElement.blur();
    }
    function lt() {
      var e, t;
      (e = f.value) === null || e === void 0 || e.select(), (t = a.value) === null || t === void 0 || t.select();
    }
    function at() {
      _.value || (f.value ? f.value.focus() : a.value && a.value.focus());
    }
    function it() {
      const {
        value: e
      } = v;
      e != null && e.contains(document.activeElement) && e !== document.activeElement && Z();
    }
    function st(e) {
      if (n.type === "textarea") {
        const {
          value: t
        } = f;
        t == null || t.scrollTo(e);
      } else {
        const {
          value: t
        } = a;
        t == null || t.scrollTo(e);
      }
    }
    function ee(e) {
      const {
        type: t,
        pair: o,
        autosize: u
      } = n;
      if (!o && u)
        if (t === "textarea") {
          const {
            value: d
          } = c;
          d && (d.textContent = `${e ?? ""}\r
`);
        } else {
          const {
            value: d
          } = i;
          d && (e ? d.textContent = e : d.innerHTML = "&nbsp;");
        }
    }
    function ut() {
      _e();
    }
    const ie = p({
      top: "0"
    });
    function dt(e) {
      var t;
      const {
        scrollTop: o
      } = e.target;
      ie.value.top = `${-o}px`, (t = S.value) === null || t === void 0 || t.syncUnifiedContainer();
    }
    let K = null;
    de(() => {
      const {
        autosize: e,
        type: t
      } = n;
      e && t === "textarea" ? K = ce(x, (o) => {
        !Array.isArray(o) && o !== Y && ee(o);
      }) : K == null || K();
    });
    let U = null;
    de(() => {
      n.type === "textarea" ? U = ce(x, (e) => {
        var t;
        !Array.isArray(e) && e !== Y && ((t = S.value) === null || t === void 0 || t.syncUnifiedContainer());
      }) : U == null || U();
    }), nn(ln, {
      mergedValueRef: x,
      maxlengthRef: Be,
      mergedClsPrefixRef: y,
      countGraphemesRef: ue(n, "countGraphemes")
    });
    const ct = {
      wrapperElRef: v,
      inputElRef: a,
      textareaElRef: f,
      isCompositing: w,
      clear: le,
      focus: ae,
      blur: rt,
      select: lt,
      deactivate: it,
      activate: at,
      scrollTo: st
    }, ft = on("Input", G, y), se = C(() => {
      const {
        value: e
      } = X, {
        common: {
          cubicBezierEaseInOut: t
        },
        self: {
          color: o,
          borderRadius: u,
          textColor: d,
          caretColor: s,
          caretColorError: A,
          caretColorWarning: F,
          textDecorationColor: R,
          border: z,
          borderDisabled: M,
          borderHover: te,
          borderFocus: ht,
          placeholderColor: vt,
          placeholderColorDisabled: pt,
          lineHeightTextarea: gt,
          colorDisabled: mt,
          colorFocus: yt,
          textColorDisabled: bt,
          boxShadowFocus: xt,
          iconSize: wt,
          colorFocusWarning: Ct,
          boxShadowFocusWarning: St,
          borderWarning: At,
          borderFocusWarning: Ft,
          borderHoverWarning: Rt,
          colorFocusError: _t,
          boxShadowFocusError: Bt,
          borderError: Et,
          borderFocusError: Pt,
          borderHoverError: It,
          clearSize: Tt,
          clearColor: $t,
          clearColorHover: Vt,
          clearColorPressed: zt,
          iconColor: Mt,
          iconColorDisabled: Dt,
          suffixTextColor: Wt,
          countTextColor: Ot,
          countTextColorDisabled: kt,
          iconColorHover: Ht,
          iconColorPressed: Nt,
          loadingColor: Kt,
          loadingColorError: Ut,
          loadingColorWarning: Lt,
          fontWeight: jt,
          [oe("padding", e)]: Gt,
          [oe("fontSize", e)]: Xt,
          [oe("height", e)]: Yt
        }
      } = b.value, {
        left: qt,
        right: Jt
      } = mn(Gt);
      return {
        "--n-bezier": t,
        "--n-count-text-color": Ot,
        "--n-count-text-color-disabled": kt,
        "--n-color": o,
        "--n-font-size": Xt,
        "--n-font-weight": jt,
        "--n-border-radius": u,
        "--n-height": Yt,
        "--n-padding-left": qt,
        "--n-padding-right": Jt,
        "--n-text-color": d,
        "--n-caret-color": s,
        "--n-text-decoration-color": R,
        "--n-border": z,
        "--n-border-disabled": M,
        "--n-border-hover": te,
        "--n-border-focus": ht,
        "--n-placeholder-color": vt,
        "--n-placeholder-color-disabled": pt,
        "--n-icon-size": wt,
        "--n-line-height-textarea": gt,
        "--n-color-disabled": mt,
        "--n-color-focus": yt,
        "--n-text-color-disabled": bt,
        "--n-box-shadow-focus": xt,
        "--n-loading-color": Kt,
        // form warning
        "--n-caret-color-warning": F,
        "--n-color-focus-warning": Ct,
        "--n-box-shadow-focus-warning": St,
        "--n-border-warning": At,
        "--n-border-focus-warning": Ft,
        "--n-border-hover-warning": Rt,
        "--n-loading-color-warning": Lt,
        // form error
        "--n-caret-color-error": A,
        "--n-color-focus-error": _t,
        "--n-box-shadow-focus-error": Bt,
        "--n-border-error": Et,
        "--n-border-focus-error": Pt,
        "--n-border-hover-error": It,
        "--n-loading-color-error": Ut,
        // clear-button
        "--n-clear-color": $t,
        "--n-clear-size": Tt,
        "--n-clear-color-hover": Vt,
        "--n-clear-color-pressed": zt,
        "--n-icon-color": Mt,
        "--n-icon-color-hover": Ht,
        "--n-icon-color-pressed": Nt,
        "--n-icon-color-disabled": Dt,
        "--n-suffix-text-color": Wt
      };
    }), E = P ? yn("input", C(() => {
      const {
        value: e
      } = X;
      return e[0];
    }), se, n) : void 0;
    return Object.assign(Object.assign({}, ct), {
      // DOM ref
      wrapperElRef: v,
      inputElRef: a,
      inputMirrorElRef: i,
      inputEl2Ref: h,
      textareaElRef: f,
      textareaMirrorElRef: c,
      textareaScrollbarInstRef: S,
      // value
      rtlEnabled: ft,
      uncontrolledValue: W,
      mergedValue: x,
      passwordVisible: V,
      mergedPlaceholder: q,
      showPlaceholder1: Se,
      showPlaceholder2: Ae,
      mergedFocus: J,
      isComposing: w,
      activated: $,
      showClearButton: Fe,
      mergedSize: X,
      mergedDisabled: _,
      textDecorationStyle: Re,
      mergedClsPrefix: y,
      mergedBordered: r,
      mergedShowPasswordOn: Q,
      placeholderStyle: ie,
      mergedStatus: Ce,
      textAreaScrollContainerWidth: re,
      // methods
      handleTextAreaScroll: dt,
      handleCompositionStart: ke,
      handleCompositionEnd: He,
      handleInput: H,
      handleInputBlur: Ke,
      handleInputFocus: Ue,
      handleWrapperBlur: Le,
      handleWrapperFocus: je,
      handleMouseEnter: Je,
      handleMouseLeave: Qe,
      handleMouseDown: qe,
      handleChange: Ge,
      handleClick: Xe,
      handleClear: Ye,
      handlePasswordToggleClick: Ze,
      handlePasswordToggleMousedown: et,
      handleWrapperKeydown: nt,
      handleWrapperKeyup: tt,
      handleTextAreaMirrorResize: ut,
      getTextareaScrollContainer: () => f.value,
      mergedTheme: b,
      cssVars: P ? void 0 : se,
      themeClass: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender
    });
  },
  render() {
    var n, y;
    const {
      mergedClsPrefix: r,
      mergedStatus: P,
      themeClass: G,
      type: b,
      countGraphemes: v,
      onRender: f
    } = this, c = this.$slots;
    return f == null || f(), l("div", {
      ref: "wrapperElRef",
      class: [`${r}-input`, G, P && `${r}-input--${P}-status`, {
        [`${r}-input--rtl`]: this.rtlEnabled,
        [`${r}-input--disabled`]: this.mergedDisabled,
        [`${r}-input--textarea`]: b === "textarea",
        [`${r}-input--resizable`]: this.resizable && !this.autosize,
        [`${r}-input--autosize`]: this.autosize,
        [`${r}-input--round`]: this.round && b !== "textarea",
        [`${r}-input--pair`]: this.pair,
        [`${r}-input--focus`]: this.mergedFocus,
        [`${r}-input--stateful`]: this.stateful
      }],
      style: this.cssVars,
      tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0,
      onFocus: this.handleWrapperFocus,
      onBlur: this.handleWrapperBlur,
      onClick: this.handleClick,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onCompositionstart: this.handleCompositionStart,
      onCompositionend: this.handleCompositionEnd,
      onKeyup: this.handleWrapperKeyup,
      onKeydown: this.handleWrapperKeydown
    }, l("div", {
      class: `${r}-input-wrapper`
    }, j(c.prefix, (i) => i && l("div", {
      class: `${r}-input__prefix`
    }, i)), b === "textarea" ? l(dn, {
      ref: "textareaScrollbarInstRef",
      class: `${r}-input__textarea`,
      container: this.getTextareaScrollContainer,
      triggerDisplayManually: !0,
      useUnifiedContainer: !0,
      internalHoistYRail: !0
    }, {
      default: () => {
        var i, a;
        const {
          textAreaScrollContainerWidth: h
        } = this, m = {
          width: this.autosize && h && `${h}px`
        };
        return l(Zt, null, l("textarea", Object.assign({}, this.inputProps, {
          ref: "textareaElRef",
          class: [`${r}-input__textarea-el`, (i = this.inputProps) === null || i === void 0 ? void 0 : i.class],
          autofocus: this.autofocus,
          rows: Number(this.rows),
          placeholder: this.placeholder,
          value: this.mergedValue,
          disabled: this.mergedDisabled,
          maxlength: v ? void 0 : this.maxlength,
          minlength: v ? void 0 : this.minlength,
          readonly: this.readonly,
          tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
          style: [this.textDecorationStyle[0], (a = this.inputProps) === null || a === void 0 ? void 0 : a.style, m],
          onBlur: this.handleInputBlur,
          onFocus: (D) => {
            this.handleInputFocus(D, 2);
          },
          onInput: this.handleInput,
          onChange: this.handleChange,
          onScroll: this.handleTextAreaScroll
        })), this.showPlaceholder1 ? l("div", {
          class: `${r}-input__placeholder`,
          style: [this.placeholderStyle, m],
          key: "placeholder"
        }, this.mergedPlaceholder[0]) : null, this.autosize ? l(cn, {
          onResize: this.handleTextAreaMirrorResize
        }, {
          default: () => l("div", {
            ref: "textareaMirrorElRef",
            class: `${r}-input__textarea-mirror`,
            key: "mirror"
          })
        }) : null);
      }
    }) : l("div", {
      class: `${r}-input__input`
    }, l("input", Object.assign({
      type: b === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : b
    }, this.inputProps, {
      ref: "inputElRef",
      class: [`${r}-input__input-el`, (n = this.inputProps) === null || n === void 0 ? void 0 : n.class],
      style: [this.textDecorationStyle[0], (y = this.inputProps) === null || y === void 0 ? void 0 : y.style],
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[0],
      disabled: this.mergedDisabled,
      maxlength: v ? void 0 : this.maxlength,
      minlength: v ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue,
      readonly: this.readonly,
      autofocus: this.autofocus,
      size: this.attrSize,
      onBlur: this.handleInputBlur,
      onFocus: (i) => {
        this.handleInputFocus(i, 0);
      },
      onInput: (i) => {
        this.handleInput(i, 0);
      },
      onChange: (i) => {
        this.handleChange(i, 0);
      }
    })), this.showPlaceholder1 ? l("div", {
      class: `${r}-input__placeholder`
    }, l("span", null, this.mergedPlaceholder[0])) : null, this.autosize ? l("div", {
      class: `${r}-input__input-mirror`,
      key: "mirror",
      ref: "inputMirrorElRef"
    }, " ") : null), !this.pair && j(c.suffix, (i) => i || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? l("div", {
      class: `${r}-input__suffix`
    }, [j(c["clear-icon-placeholder"], (a) => (this.clearable || a) && l(pe, {
      clsPrefix: r,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      placeholder: () => a,
      icon: () => {
        var h, m;
        return (m = (h = this.$slots)["clear-icon"]) === null || m === void 0 ? void 0 : m.call(h);
      }
    })), this.internalLoadingBeforeSuffix ? null : i, this.loading !== void 0 ? l(bn, {
      clsPrefix: r,
      loading: this.loading,
      showArrow: !1,
      showClear: !1,
      style: this.cssVars
    }) : null, this.internalLoadingBeforeSuffix ? i : null, this.showCount && this.type !== "textarea" ? l(he, null, {
      default: (a) => {
        var h;
        const {
          renderCount: m
        } = this;
        return m ? m(a) : (h = c.count) === null || h === void 0 ? void 0 : h.call(c, a);
      }
    }) : null, this.mergedShowPasswordOn && this.type === "password" ? l("div", {
      class: `${r}-input__eye`,
      onMousedown: this.handlePasswordToggleMousedown,
      onClick: this.handlePasswordToggleClick
    }, this.passwordVisible ? ne(c["password-visible-icon"], () => [l(ge, {
      clsPrefix: r
    }, {
      default: () => l(xn, null)
    })]) : ne(c["password-invisible-icon"], () => [l(ge, {
      clsPrefix: r
    }, {
      default: () => l(wn, null)
    })])) : null]) : null)), this.pair ? l("span", {
      class: `${r}-input__separator`
    }, ne(c.separator, () => [this.separator])) : null, this.pair ? l("div", {
      class: `${r}-input-wrapper`
    }, l("div", {
      class: `${r}-input__input`
    }, l("input", {
      ref: "inputEl2Ref",
      type: this.type,
      class: `${r}-input__input-el`,
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[1],
      disabled: this.mergedDisabled,
      maxlength: v ? void 0 : this.maxlength,
      minlength: v ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0,
      readonly: this.readonly,
      style: this.textDecorationStyle[1],
      onBlur: this.handleInputBlur,
      onFocus: (i) => {
        this.handleInputFocus(i, 1);
      },
      onInput: (i) => {
        this.handleInput(i, 1);
      },
      onChange: (i) => {
        this.handleChange(i, 1);
      }
    }), this.showPlaceholder2 ? l("div", {
      class: `${r}-input__placeholder`
    }, l("span", null, this.mergedPlaceholder[1])) : null), j(c.suffix, (i) => (this.clearable || i) && l("div", {
      class: `${r}-input__suffix`
    }, [this.clearable && l(pe, {
      clsPrefix: r,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      icon: () => {
        var a;
        return (a = c["clear-icon"]) === null || a === void 0 ? void 0 : a.call(c);
      },
      placeholder: () => {
        var a;
        return (a = c["clear-icon-placeholder"]) === null || a === void 0 ? void 0 : a.call(c);
      }
    }), i]))) : null, this.mergedBordered ? l("div", {
      class: `${r}-input__border`
    }) : null, this.mergedBordered ? l("div", {
      class: `${r}-input__state-border`
    }) : null, this.showCount && b === "textarea" ? l(he, null, {
      default: (i) => {
        var a;
        const {
          renderCount: h
        } = this;
        return h ? h(i) : (a = c.count) === null || a === void 0 ? void 0 : a.call(c, i);
      }
    }) : null);
  }
});
export {
  Qn as default,
  Sn as inputProps
};
